// Per-user retailer visibility, persisted in local storage only.
//
// We store the set of *disabled* chain slugs, not the enabled ones, so the
// default (and any newly-appearing chain) is "enabled" without us having to
// know the full chain list up front.

const STORAGE_KEY = 'disabledRetailers'

function safeReadSet() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return new Set()
    const parsed = JSON.parse(raw)
    return new Set(Array.isArray(parsed) ? parsed : [])
  } catch {
    return new Set()
  }
}

function safeWriteSet(set) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]))
  } catch {
    /* ignore */
  }
}

export function getDisabledRetailers() {
  return safeReadSet()
}

export function isRetailerEnabled(chain) {
  return !safeReadSet().has(chain)
}

// Enable/disable a single chain. Returns the updated disabled set.
export function setRetailerEnabled(chain, enabled) {
  const set = safeReadSet()
  if (enabled) {
    set.delete(chain)
  } else {
    set.add(chain)
  }
  safeWriteSet(set)
  return set
}
